module.exports = __webpack_public_path__ + "media/buy_report_icons/stolen_data-5f558c6a.svg";